
interface Message {
  content: string;
  isBot: boolean;
  timestamp: Date;
}

interface Tool {
  name: string;
  description: string;
  execute: (params: any) => Promise<any>;
}

interface AgentAction {
  tool: string;
  params: any;
}

// Cette logique de cache et rate limiting n'est plus nécessaire avec n8n
// Tout est géré par le webhook n8n directement dans ChatBot.tsx

const availableTools: Tool[] = [
  {
    name: 'navigate_to_section',
    description: 'Navigue vers une section spécifique du site',
    execute: async (params: { section: string }) => {
      // Mapper les sections en français vers les sections en anglais
      const sectionMap: { [key: string]: string } = {
        'compétences': 'about',
        'projets': 'projects',
        'contact': 'contact'
      };

      const targetSection = sectionMap[params.section.toLowerCase()] || params.section.toLowerCase();
      
      if (['about', 'projects', 'contact'].includes(targetSection)) {
        // Retourner l'URL complète pour la navigation
        return { 
          success: true, 
          section: targetSection,
          url: `${window.location.origin}/${targetSection}`
        };
      }
      
      return { success: false, error: 'Section non trouvée' };
    }
  },
  {
    name: 'open_linkedin',
    description: 'Ouvre le profil LinkedIn dans un nouvel onglet',
    execute: async () => {
      window.open('https://linkedin.com/in/omar-belaid/', '_blank');
      return { success: true };
    }
  },
  {
    name: 'download_cv',
    description: 'Propose le téléchargement du CV',
    execute: async () => {
      return { 
        success: true, 
        url: `${window.location.origin}/cv/omar-belaid-cv.pdf`,
        filename: 'CV_Omar_Belaid.pdf'
      };
    }
  },
  {
    name: 'show_project_details',
    description: 'Affiche les détails d\'un projet spécifique',
    execute: async (params: { projectName: string }) => {
      // Logique pour afficher les détails du projet
      return { success: true, projectName: params.projectName };
    }
  },
  {
    name: 'send_contact_request',
    description: 'Envoie une demande de contact',
    execute: async (params: { name: string; email: string; message: string }) => {
      // Logique pour envoyer la demande de contact
      return { success: true, contact: params };
    }
  }
];

export const executeAgentAction = async (action: AgentAction): Promise<any> => {
  const tool = availableTools.find(t => t.name === action.tool);
  if (!tool) {
    console.error(`Tool ${action.tool} not found`);
    throw new Error(`Tool ${action.tool} not found`);
  }
  try {
    const result = await tool.execute(action.params);
    return result;
  } catch (error) {
    console.error('Error executing tool:', error);
    throw error;
  }
};

// Cette fonction n'est plus utilisée - tout passe maintenant par le webhook n8n dans ChatBot.tsx
// Conservée temporairement pour référence mais ne devrait plus être appelée
export const getAIResponse = async (messages: Message[]): Promise<string> => {
  console.warn('getAIResponse is deprecated - use n8n webhook directly in ChatBot.tsx');
  return "Cette fonction est obsolète. Veuillez utiliser le chat directement.";
}; 